import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';
import FadeIn from '../Animations/FadeIn';
import { Button } from '../Components/Button';

const introCopy = [
  'Jag heter Sandra och arbetar som samtalsterapeut, stressterapeut och hälsocoach.',
  'Under många år har jag mött människor som fungerar utåt men samtidigt bär på stress, oro, självkritik, överprestation eller en känsla av att ständigt behöva börja om.',
  'Många har försökt mycket redan. Läsa på. Skärpa rutinerna. Tänka mer positivt. Försöka få bättre disciplin.',
  'Ändå fortsätter samma mönster att komma tillbaka.'
];

const whyCopy = [
  'Det jag gång på gång såg var att problemet sällan handlade om vilja.',
  'Förändringen började helt enkelt för långt ut på ytan.',
  'Det blev grunden till mitt sätt att arbeta och senare det som växte fram till ROT-modellen, där vi arbetar med nervsystemet, självkänslan och det som driver symtomen bakom kulisserna.',
  'Jag vet också på ett personligt plan hur lätt det är att tappa kontakten med sig själv när livet ställer höga krav. Hur lätt det är att fortsätta fungera, samtidigt som man tappar fotfästet inåt.',
  'Det är en av anledningarna till att jag bryr mig så mycket om det här arbetet.'
];

const workCopy = [
  'Jag tror inte på mer press, skuld eller krav.',
  'Jag tror på förståelse, trygghet och struktur.',
  'På förändring som håller – också när livet händer.'
];

const backgroundItems = [
  'Certifierad samtalsterapeut',
  'Certifierad stressterapeut',
  'Diplomerad hälsocoach',
  'Kostrådgivare'
];

export const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero__content">
          {/* <p className="eyebrow">Om mig</p> */}

          <h1>Om mig – och varför jag arbetar med roten</h1>

          <div className="divider" />

          <div className="about-hero__text">
            {introCopy.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className="about-hero__actions">
            <Button text="Boka samtal" className="about-hero__button" onClick={() => navigate('/booking')} />
            <Button text="Utforska GROW" className="about-hero__button" variant="secondary" onClick={() => navigate('/membership')} />
          </div>
        </div>

        <FadeIn className="about-hero__image">
          <img src="/images/IMG_3996.jpeg" alt="Sandra" />
        </FadeIn>
      </section>

      <section className="intro-columns">
        <FadeIn className="intro-columns__wrap">
          <article>
            <span className="icon">🌱</span>
            <h2>Min väg hit</h2>
            <div className="intro-columns__text">
              <p>{whyCopy[0]}</p>
              <p>{whyCopy[1]}</p>
            </div>
          </article>

          <article>
            <span className="icon">𖧧</span>
            <h2>Varför roten?</h2>
            <div className="intro-columns__text">
              <p>{whyCopy[2]}</p>
              <p>{whyCopy[3]}</p>
              <p>{whyCopy[4]}</p>
            </div>
          </article>

          <article>
            <span className="icon">♡</span>
            <h2>Mitt sätt att arbeta</h2>
            <div className="intro-columns__text">
              {workCopy.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </article>
        </FadeIn>
      </section>

      <section className="quote-section">
        <span>“</span>
        <h2>
          Jag tror inte på mer press, skuld eller krav.<br />
          Jag tror på förståelse, trygghet och struktur.
        </h2>
      </section>

      <section className="cards-section">
        <FadeIn className="cards-section__grid">
          <article className="card card--about">
            <div className="card-icon">☰</div>
            <h3>Min bakgrund</h3>
            <ul>
              {backgroundItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <article className="card card--about">
            <div className="card-icon">✿</div>
            <h3>Det jag tror på</h3>
            <p>På förändring som håller – också när livet händer.</p>
            <a href="/membership">Läs mer →</a>
          </article>

          <article className="card card--about">
            <div className="card-icon">♡</div>
            <h3>Därför gör jag det här</h3>
            <p>Hos mig får du inte bara samtal.</p>
            <p>Du får en tydlig metod, professionell vägledning och ett tryggt sammanhang för verklig förändring.</p>
            <a href="/booking">Boka ett samtal →</a>
          </article>
        </FadeIn>
      </section>
    </div>
  );
};
